import { SCOPE } from "@/constants/scope";

export const PA_COLUMNS = [
  { key: "patientName", label: "Patient", sortable: true, width: "180px", sticky: true, pinned: true },
  { key: "identifiers", label: "Identifiers", sortable: false, width: "200px" },
  { key: "status", label: "Status", sortable: true, width: "190px" },
  { key: "tags", label: "Tags", sortable: false, width: "180px" },
  { key: "medication", label: "Medication", sortable: true, width: "250px" },
  { key: "insurance", label: "Insurance", sortable: true, width: "150px" },
  { key: "provider", label: "Provider", sortable: false, width: "150px" },
  { key: "priorAuthNumber", label: "PA Number", sortable: false, width: "130px", mono: true },
  { key: "prescriptionNumber", label: "Rx Number", sortable: false, width: "130px", mono: true },
  { key: "dateCreated", label: "Created", sortable: true, width: "140px", mono: true, datetime: true },
  { key: "modifiedBy", label: "Modified By", sortable: true, width: "130px" },
  { key: "actions", label: "", sortable: false, width: "48px", fixed: true },
];

// NOTE: intake columns intentionally do NOT declare a `sortable` flag.
// Sortability is driven entirely by the `sortable_fields` list returned with
// the combined-feed response (see `SORTABLE_FIELDS` in
// portal/api/intake/views.py). IntakeTablePage's `displayColumns` computed
// injects `sortable` onto each column at render time from that list.
export const INTAKE_COLUMNS = [
  { key: "patientName", label: "Patient Name", width: "180px", sticky: true, pinned: true },
  { key: "mrn", label: "MRN", width: "100px", mono: true },
  { key: "status", label: "Status", width: "220px" },
  { key: "tags", label: "Tags", width: "180px" },
  { key: "dateReceived", label: "Date Received", width: "130px", mono: true, datetime: true },
  { key: "insurance", label: "Insurance", width: "150px" },
  { key: "medication", label: "Medication", width: "250px" },
  { key: "documentTypes", label: "Doc Type", width: "140px" },
  { key: "provider", label: "Provider", width: "150px" },
  { key: "sentBy", label: "Sent By", width: "130px" },
  { key: "modifiedBy", label: "Modified By", width: "130px" },
  { key: "actions", label: "", width: "48px", fixed: true },
];

export const COLUMN_TABS = {
  [SCOPE.PA]: ["columns", "tags", "statusNotifications"],
  [SCOPE.INTAKE]: ["columns", "tags"],
};
